import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import PositionsSets from "@components/modules/brands/positions-sets";
import { NavigationBrand } from "@components/widgets/AppSubNav/NavigationBrand";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    fullWidth
    title={t`Hourly rates and commissions`}
    navigation={<NavigationBrand id={id} variant="panel" />}
  >
    <PositionsSets id={id} />
  </MainLayout>
);

const RouteComponent = withId(Page);

export const Route = createFileRoute("/brands/hourly-rates-and-commissions")({
  component: RouteComponent,
});
